import React from "react";
import MuiButton from "@mui/material/Button";
import { ButtonProps as MuiButtonProps } from "@mui/material/Button";

interface ButtonProps extends MuiButtonProps {
  onClick: () => void;
  variant?: any;
  size?: any;
  width?: string | number;
  children?: React.ReactNode;
}

const Button: React.FC<ButtonProps> = ({
  children,
  onClick,
  variant = "contained",
  size = "medium",
  width = "100%",
  ...rest
}) => {
  return (
    <MuiButton
      style={{ width }}
      size={size}
      variant={variant}
      onClick={onClick}
      {...rest}
    >
      {children}
    </MuiButton>
  );
};

export default Button;
